import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { CircularProgress } from "@material-ui/core";

import infractionNames from './InfractionNames.json';
import { fetchWithAuth } from './utils/api';
import { IconButton, Typography, Grid, Card, CardContent, Box, Button, TextField } from "@material-ui/core";
import { 
    FaPaperPlane as Send, 
    FaTimes as Cancel, 
    FaMapMarkerAlt as LocationOn, 
    FaExclamationTriangle as WarningAmber, 
    FaHashtag as Numbers, 
    FaCalendarCheck as EventAvailable, 
    FaTag as Label, 
    FaPalette as Palette 
  } from "react-icons/fa";

import { FaTimes as CloseIcon, FaMap as MapIcon, FaInfoCircle as InfoIcon } from "react-icons/fa";

import rejectIcon from './rejectIcon.gif';
import doneIcon from './doneIcon.gif';

import CryptoJS from 'crypto-js';
import debounce from 'lodash/debounce';

import { Link, useLocation } from "react-router-dom";
import { Modal } from "@material-ui/core";
import icon from './websiteIcon.jpg'; // Your company logo

import './App.css';

const Talika = ({ token }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const videoRef = useRef(null);
  const [cellValues, setCellValues] = useState({});
  const [filterNp, setFilterNp] = useState('');
  const [filterInfractionType, setFilterInfractionType] = useState('');
  const [boxX, setBoxX] = useState(0.0);
  const [boxY, setBoxY] = useState(0.0);
  const [boxHeight, setBoxHeight] = useState(0.0);
  const [boxWidth, setBoxWidth] = useState(0.0);
  const [currentOverlays, setCurrentOverlays] = useState([]);
  const [openDocModal, setOpenDocModal] = useState(false);
  const [isInsuranceValid, setIsInsuranceValid] = useState(false);
  const [insuranceAmt, setInsuranceAmt] = useState(0);
  const [isRcValid, setIsRcValid] = useState(false);
  const [rcAmt, setRcAmt] = useState(0);
  const [isPuccValid, setIsPuccValid] = useState(false);
  const [puccAmt, setPuccAmt] = useState(0);
  const [isPermitValid, setIsPermitValid] = useState(false);
  const [permitAmt, setPermitAmt] = useState(0);
  const [showImageModal, setShowImageModal] = useState(false);
  const [croppedImageUrl, setCroppedImageUrl] = useState(null);
  const [isTimeLessThan5, setIsTimeLessThan5] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState({});
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openIssueChallanModal, setOpenIssueChallanModal] = useState(false);
  const [openIssueChallanFormModal, setOpenIssueChallanFormModal] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openAbout, setOpenAbout] = useState(false);

  const decrypt = (encryptedText) => {
    try {
      const parts = encryptedText.split(':');
      const iv = CryptoJS.enc.Hex.parse(parts[0]);
      const encrypted = CryptoJS.enc.Hex.parse(parts[1]);
      const key = CryptoJS.enc.Utf8.parse('12345678901234567890123456789201');

      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        key,
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      );
      const base64Decoded = CryptoJS.enc.Utf8.stringify(decrypted);
      return atob(base64Decoded);
    } catch (err) {
      console.error('Decrypt error:', err);
      return '';
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth('https://be-lb.chitragupta.co/get-evidences');
      const evidences = await response.json();
      setData(evidences.map((item, index) => ({ ...item, index })));
    } catch (error) {
      console.error('Error fetching evidences data :', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token]);

  // Issue Challan
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetchWithAuth('https://be-lb.chitragupta.co/issue-challan', {
        method: 'POST',
        body: JSON.stringify({
          object_Id: selectedEvidence.object_id.slice(0, 15).toUpperCase(),
          mnum: '+91' + inputValue,
          cleaned_np: selectedEvidence.cleaned_np,
          amount: selectedEvidence.infraction_amount,
          reason: infractionNames[selectedEvidence.label_class],
          time: selectedEvidence.time + ' IST'
        })
      });

      if (response.ok) {
        console.log('Challan request sent successfully');
      } else {
        console.error('Challan request failed');
      }
    } catch (error) {
      console.error('Error during SNS:', error);
    } finally {
      setIsSubmitting(false);
      handleCloseIssueChallanFormModal();
      setOpenIssueChallanModal(true);
    }
  };

  // Overlays
  const endTime = startTime + duration;
  const overlays = [
    {
      x: (boxX * 0.25).toFixed(2),
      y: (boxY * 0.25).toFixed(2),
      height: (boxHeight * 0.25).toFixed(2),
      width: (boxWidth * 0.25).toFixed(2),
      startTime: isTimeLessThan5 ? startTime - 0.1 : startTime + 4.4,
      endTime: isTimeLessThan5 ? startTime + 0.3 : startTime + 4.8
    }
  ];
  const slowMoStart = isTimeLessThan5 ? startTime - 0.3 : startTime + 4.2;
  const slowMoEnd = isTimeLessThan5 ? startTime + 0.1 : startTime + 4.6;

  // Video logic
  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = isTimeLessThan5 ? 0 : startTime;
      videoRef.current.play();
    }
  };

  const handleVideoTimeUpdate = () => {
    const video = videoRef.current;
    if (video && video.currentTime >= endTime) {
      video.pause();
    }

    // Show overlays
    const visibleOverlays = overlays.filter(
      (overlay) =>
        overlay.startTime <= video.currentTime && overlay.endTime >= video.currentTime
    );
    setCurrentOverlays(visibleOverlays);

    // Slow motion
    if (video.currentTime >= slowMoStart && video.currentTime < slowMoEnd) {
      video.playbackRate = 0.1;
    } else {
      video.playbackRate = 1;
    }
  };

  // Document Infraction details
  const handleDocumentInfractionClick = (evidence) => {
    setOpenDocModal(true);
    setIsInsuranceValid(evidence.insurance_infraction_flag === 0);
    setInsuranceAmt(evidence.elig_insur_infraction_amount);

    setIsRcValid(evidence.rc_infraction_flag === 0);
    setRcAmt(evidence.elig_rc_infraction_amount);

    setIsPuccValid(evidence.pucc_infraction_flag === 0);
    setPuccAmt(evidence.elig_pucc_infraction_amount);

    setIsPermitValid(evidence.permit_infraction_flag === 0);
    setPermitAmt(evidence.elig_permit_infraction_amount);
  };
  const handleDocCloseModal = () => setOpenDocModal(false);

  // "Click to load" location
  const handleLoadValueClick = async (lat, long, lat_long) => {
    try {
      setCellValues((prev) => ({ ...prev, [lat_long]: 'loading' }));
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${long}&zoom=18&addressdetails=1`
      );
      const result = await response.json();
      setCellValues((prev) => ({
        ...prev,
        [lat_long]: result.display_name.slice(0, 30) + '...'
      }));
    } catch (error) {
      console.error('Error fetching location:', error);
      setCellValues((prev) => ({ ...prev, [lat_long]: 'Error' }));
    }
  };

  // Filter
  const handleFilter = (rows) => {
    return rows.filter((row) => {
      const matchesNp = row.cleaned_np.toLowerCase().includes(filterNp.toLowerCase());
      const rowInfractionName = infractionNames[row.label_class];
      const matchesType = filterInfractionType ? rowInfractionName === filterInfractionType : true;
      return matchesNp && matchesType;
    });
  };

  // Unique infraction names
  const uniqueNames = [
    ...new Set(data.map((row) => infractionNames[row.label_class]).filter(Boolean))
  ];

  // On "Verify" => load video
  const handleVerifyClick = async (evidence) => {
    try {
      const response = await fetchWithAuth('https://be-lb.chitragupta.co/get-infraction', {
        method: 'POST',
        body: JSON.stringify({
          object_Id: evidence.object_id
        })
      });
      const result = await response.json();

      const videoUrl = decrypt(result.encryptedUrl);

      const vitarakaUrl = "https://vitaraka.chitragupta.co/videos/" + decodeURIComponent(new URL(videoUrl).pathname.substring(1));

      setSelectedEvidence(evidence);
      setBoxX(result.x);
      setBoxY(result.y);
      setBoxHeight(result.height);
      setBoxWidth(result.width);
      // setSelectedVideo(videoUrl);
      setSelectedVideo(vitarakaUrl);

      if (result.startTime === 0) {
        setStartTime(evidence.frame / 30);
        setIsTimeLessThan5(true);
      } else {
        setStartTime(result.startTime);
        setIsTimeLessThan5(false);
      }
      setDuration(10);
      setOpenModal(true);
    } catch (err) {
      console.error('Error fetching video:', err);
    }
  };

  // On "Image" => load cropped image
//   const handleImageIconClick = async (evidence) => {
//     try {
//       const response = await fetchWithAuth('https://be-lb.chitragupta.co/get-infraction', {
//         method: 'POST',
//         body: JSON.stringify({ object_Id: evidence.object_id })
//       });
//       const result = await response.json();

//       setShowImageModal(true);
//       const videoUrl = result.signedUrl;
//       const time = result.startTime === 0 ? evidence.frame / 30 : result.startTime + 4.5;
//       renderCroppedImageFromVideo(videoUrl, { x: result.x, y: result.y, width: result.width, height: result.height }, time);
//     } catch (error) {
//       console.error('Error fetching video for image:', error);
//     }
//   };

//   const renderCroppedImageFromVideo = (videoUrl, bbox, frameTime) => {
//     const video = document.createElement('video');
//     video.crossOrigin = 'anonymous';
//     video.src = videoUrl;

//     video.onloadedmetadata = () => {
//       video.currentTime = frameTime;
//       video.onseeked = () => {
//         const canvas = document.createElement('canvas');
//         const ctx = canvas.getContext('2d');
//         canvas.width = bbox.width;
//         canvas.height = bbox.height;

//         ctx.drawImage(
//           video,
//           bbox.x,
//           bbox.y,
//           bbox.width,
//           bbox.height,
//           0,
//           0,
//           bbox.width,
//           bbox.height
//         );
//         const dataUrl = canvas.toDataURL('image/png');
//         setCroppedImageUrl(dataUrl);
//       };
//     };
//   };

  // Close modals
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedVideo(null);
    setCurrentOverlays([]);
  };
  const handleImageCloseModal = () => {
    setShowImageModal(false);
    setCroppedImageUrl(null);
  };

  // Reject
  const handleRejectModal = () => {
    setOpenModal(false);
    setSelectedVideo(null);
    setCurrentOverlays([]);
    setOpenRejectModal(true);
  };
  const handleCloseRejectModal = () => setOpenRejectModal(false);

  // Issue
  const handleIssueModal = () => {
    setOpenModal(false);
    setSelectedVideo(null);
    setCurrentOverlays([]);
    setOpenIssueChallanFormModal(true);
  };
  const handleCloseIssueChallanModal = () => setOpenIssueChallanModal(false);
  const handleCloseIssueChallanFormModal = () => setOpenIssueChallanFormModal(false);

  // Table columns
  const columns = [
    {
      name: 'Vehicle Number Plate',
      selector: (row) => row.cleaned_np,
      sortable: true,
      maxWidth: '150px'
    },
    {
      name: 'Infraction Type',
      selector: (row) => infractionNames[row.label_class],
      sortable: true
    },
    {
      name: 'Time',
      selector: (row) => (row.time ? row.time + ' IST' : 'Not Available'),
      sortable: true,
      maxWidth: '150px'
    },
    {
      name: 'Vehicle Details',
      selector: (row) =>
        `${row.response_bodyresultvehiclemanufacturername}, ${row.response_bodyresultmodel}`,
      sortable: false
    },
    {
      name: 'Vehicle Colour',
      selector: (row) => row.response_bodyresultvehiclecolour,
      sortable: true,
      maxWidth: '200px'
    },
    {
      name: 'Evidence',
      cell: (row) => (
        <div className="evidence-container">
          <button onClick={() => handleVerifyClick(row)}>Video</button>
          {/* Optionally, add an Image button again:
              <button onClick={() => handleImageIconClick(row)}>Image</button> */}
        </div>
      ),
      maxWidth: '70px'
    },
    {
      name: 'Document Infractions',
      cell: (row) => (
        <button onClick={() => handleDocumentInfractionClick(row)}>
          Details
        </button>
      ),
      maxWidth: '70px'
    },
    {
      name: 'Infraction Amount',
      selector: (row) =>
        new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0
        }).format(row.infraction_amount),
      maxWidth: '120px'
    },
    {
      name: 'Location',
      cell: (row) => {
        const lat_long = `${row.latitude}_${row.longitude}`;
        const cellValue = cellValues[lat_long];
        const googleMapLink = `https://maps.google.com/?q=${row.latitude},${row.longitude}`;
        return (
          <div
            onClick={() => handleLoadValueClick(row.latitude, row.longitude, lat_long)}
            style={{ cursor: 'pointer' }}
          >
            {cellValue === 'loading' ? (
              <CircularProgress size={20} />
            ) : cellValue ? (
              <a href={googleMapLink} target="_blank" rel="noopener noreferrer">
                {cellValue}
              </a>
            ) : (
              <span>
                Click to load<i className="reload-icon" />
              </span>
            )}
          </div>
        );
      },
      maxWidth: '250px'
    }
  ];

  // Field cards on the video modal
  const fields = [
    {
      label: 'Infraction Type',
      value: infractionNames[selectedEvidence.label_class],
      icon: <WarningAmber />
    },
    {
      label: 'Vehicle Number Plate',
      value: selectedEvidence.cleaned_np,
      icon: <Numbers />
    },
    {
      label: 'Time',
      value: selectedEvidence.time ? selectedEvidence.time + ' IST' : 'Not Available',
      icon: <EventAvailable />
    },
    {
      label: 'Vehicle Details',
      value: `${selectedEvidence.response_bodyresultvehiclemanufacturername}`.split(" ")[0]+` ,${selectedEvidence.response_bodyresultmodel}`.slice(0, 20) + "...",
      icon: <Label />
    },
    {
      label: 'Vehicle Colour',
      value: selectedEvidence.response_bodyresultvehiclecolour,
      icon: <Palette />
    },
    {
      label: 'Location',
      value: (
        <div
          onClick={() =>
            handleLoadValueClick(
              selectedEvidence.latitude,
              selectedEvidence.longitude,
              `${selectedEvidence.latitude}_${selectedEvidence.longitude}`
            )
          }
          style={{ cursor: 'pointer' }}
        >
          {cellValues[`${selectedEvidence.latitude}_${selectedEvidence.longitude}`] ===
          'loading' ? (
            <CircularProgress size={20} />
          ) : cellValues[`${selectedEvidence.latitude}_${selectedEvidence.longitude}`] ? (
            <a
              href={`https://maps.google.com/?q=${selectedEvidence.latitude},${selectedEvidence.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {cellValues[`${selectedEvidence.latitude}_${selectedEvidence.longitude}`]}
            </a>
          ) : (
            <span>
              Click to load<i className="reload-icon" />
            </span>
          )}
        </div>
      ),
      icon: <LocationOn />
    }
  ];

  const FieldCard = ({ field }) => (
    <Card style={{ margin: '0px 0' }}>
      <CardContent style={{ padding: '4px', marginLeft: '8px' }}>
        <Box display="flex" alignItems="center">
          {field.icon}
          <Typography component="span" style={{ marginLeft: '10px', fontSize: '11px' }}>
            {field.label}
          </Typography>
        </Box>
        <Typography
          style={{ marginTop: '5px', color: '#323f51', fontSize: '13px', paddingTop: '1px' }}
          fontWeight="bold"
        >
          {field.value}
        </Typography>
      </CardContent>
    </Card>
  );

  const location = useLocation();

  const handleMapIconClick = (e) => {
    if (location.pathname === "/") {
      window.location.href = window.location.href; // Forces a full page reload
    } else {
      window.location.href = "/"; // Navigates and reloads if on another route
    }
  };

  return (
    <div className="Talika">
        <div className="header-with-icon">
          <img src={icon} alt="Icon" className="header-icon" />
          <h1>Chitragupta Infraction Verification Tool</h1>
        </div>
        <div
        style={{
          position: "absolute",
          top: 16,
          right: 80,
          display: "flex",
          gap: "10px",
          zIndex: 999,
        }}
      >
        {/* About Button */}
        <IconButton onClick={() => setOpenAbout(true)}>
          <InfoIcon size={25} />
        </IconButton>

        {/* Link to Map (Brahmand) */}
        <Link to="/" onClick={handleMapIconClick}>
          <IconButton>
            <MapIcon size={25} />
          </IconButton>
        </Link>
      </div>

      {/* ===== ABOUT MODAL ===== */}
      <Modal open={openAbout} onClose={() => setOpenAbout(false)}>
        <div className="about-modal-content">
          <h2>About Karma Infraction Verification Tool</h2>
          <p>This tool is designed to verify infractions via video, image & details.</p>
          <h3>About Chitragupta.co</h3>
          <p>
            Chitragupta is a planetary-scale sensory data company. We observe the world
            through vision, audio & other sensors, and make it useful.
          </p>
          <button
            onClick={() => setOpenAbout(false)}
            className="close-about-modal-button"
          >
            X
          </button>
        </div>
      </Modal>
        <br/><br/>
      {/* ====== FILTERS ====== */}
      <div className="filter-container">
        <input
          type="text"
          placeholder="Filter by Number Plate"
          value={filterNp}
          onChange={(e) => setFilterNp(e.target.value)}
          className="filter-input"
        />
        <select
          value={filterInfractionType}
          onChange={(e) => setFilterInfractionType(e.target.value)}
          className="filter-select"
        >
          <option value="">All Infraction Type</option>
          {uniqueNames.map((name, index) => (
            <option key={index} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>

      {/* ====== DATA TABLE ====== */}
      <DataTable
        columns={columns}
        data={handleFilter(data)}
        progressPending={loading}
        pagination
        paginationPerPage={10}
        customStyles={tableCustomStyles}
      />

      {/* ====== VIDEO MODAL ====== */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <div className="modal-content">
          <button className="close-modal-button" onClick={handleCloseModal}>
            Close
          </button>
          {selectedVideo && (
            <video
              ref={videoRef}
              key={selectedVideo}
              muted
              preload="metadata"
              className="watermarked-video"
              onLoadedMetadata={handleLoadedMetadata}
              onTimeUpdate={handleVideoTimeUpdate}
              controls
              width="1280"
              height="720"
              disablePictureInPicture
              controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
              onContextMenu={(e) => e.preventDefault()}
            >
              <source src={selectedVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
          {currentOverlays.map((overlay, index) => (
            <div
              key={index}
              className="overlay"
              style={{
                top: `${overlay.y}px`,
                left: `${overlay.x}px`,
                width: `${overlay.width}px`,
                height: `${overlay.height}px`
              }}
            />
          ))}
          <div className="watermark">Chitragupta.co</div>

          {/* FIELD-VALUE SECTION BELOW VIDEO */}
          <div className="talika-field-value-section">
            <Box sx={{ display: 'flex', width: '100%' }}>
              <Box sx={{ width: '85%' }}>
                <Grid container className="grid-container" spacing={1}>
                  {fields.map((field, index) => (
                    <Grid item xs={6} sm={3} md={4} key={index}>
                      <FieldCard field={field} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
              <Box
                sx={{
                  width: '15%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  padding: '5px',
                  alignItems: 'center'
                }}
              >
                <button className="issue-button" onClick={handleIssueModal}>
                  Issue Challan
                  <Send style={{ marginLeft: '8px' }} />
                </button>
                <button className="reject-button" onClick={handleRejectModal}>
                  Reject Infraction
                  <Cancel style={{ marginLeft: '8px' }} />
                </button>
              </Box>
            </Box>
          </div>
        </div>
      </Modal>

      {/* ====== DOC INFRACTION MODAL ====== */}
      <Modal open={openDocModal} onClose={handleDocCloseModal}>
        <div className="doc-modal-content">
          <button className="close-doc-modal-button" onClick={handleDocCloseModal}>
            Close
          </button>
          <DataTable
            columns={[
              { name: 'Document Type', selector: (item) => item.type },
              { name: 'Validity', selector: (item) => (item.validity ? 'Valid' : 'Expired') },
              {
                name: 'Infraction Amount',
                selector: (item) =>
                  new Intl.NumberFormat('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                    minimumFractionDigits: 0
                  }).format(item.amount)
              }
            ]}
            data={[
              { type: 'Insurance', validity: isInsuranceValid, amount: insuranceAmt },
              { type: 'RC', validity: isRcValid, amount: rcAmt },
              { type: 'PUCC', validity: isPuccValid, amount: puccAmt },
              { type: 'Permit', validity: isPermitValid, amount: permitAmt }
            ]}
            customStyles={tableCustomStyles}
          />
        </div>
      </Modal>

      {/* ====== CROPPED IMAGE MODAL ====== */}
      <Modal open={showImageModal} onClose={handleImageCloseModal}>
        <div className="img-modal-content">
          {croppedImageUrl ? (
            <img src={croppedImageUrl} alt="cropped-evidence" />
          ) : (
            <p>Loading image...</p>
          )}
        </div>
      </Modal>

      {/* ====== REJECT MODAL ====== */}
      <Modal open={openRejectModal} onClose={handleCloseRejectModal}>
        <div className="reject-modal-content">
          <center>
            <img src={rejectIcon} alt="Icon" />
            <h2>Infraction Rejected !</h2>
            <p>Infraction is rejected and sent for review to Chitragupta team.</p>
          </center>
          <button onClick={handleCloseRejectModal} className="closeIcon">
            <CloseIcon fontSize="large" />
          </button>
        </div>
      </Modal>

      {/* ====== ISSUE CHALLAN CONFIRMATION ====== */}
      <Modal open={openIssueChallanModal} onClose={handleCloseIssueChallanModal}>
        <div className="issue-modal-content">
          <center>
            <img src={doneIcon} alt="Icon" className="gif-icon" />
            <h2>Challan Issued !</h2>
            <p>Challan has been raised by Chitragupta team.</p>
          </center>
          <button onClick={handleCloseIssueChallanModal} className="issueIcon">
            <CloseIcon fontSize="large" />
          </button>
        </div>
      </Modal>

      {/* ====== ISSUE CHALLAN FORM ====== */}
      <Modal open={openIssueChallanFormModal} onClose={handleCloseIssueChallanFormModal}>
        <div className="issue-modal-content">
          <center>
            <h2>Enter Mobile Number to raise challan:</h2>
            <p>Please enter mobile number without country code (+91 or 0).</p>
          </center>
          <form onSubmit={handleSubmit} style={{ textAlign: 'center' }}>
            <TextField
              label="Enter Mobile Number"
              value={inputValue}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              required
            />
            <Button type="submit" variant="contained" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </Button>
          </form>
          <button onClick={handleCloseIssueChallanFormModal} className="issueIcon">
            <CloseIcon fontSize="large" />
          </button>
        </div>
      </Modal>
    </div>
  );
};

// Table custom styles
const tableCustomStyles = {
  table: {
    style: {
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
    }
  },
  header: {
    style: {
      backgroundColor: '#fe5c4c',
      color: 'white',
      fontSize: '16px',
      fontWeight: 'bold',
      padding: '12px'
    }
  },
  headRow: {
    style: {
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      backgroundColor: '#fe5c4c'
    }
  },
  headCells: {
    style: {
      color: 'white',
      padding: '12px',
      fontSize: '15px',
      fontWeight: 'bold',
      textAlign: 'center',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      overflow: 'visible',
      textOverflow: 'clip'
    }
  },
  rows: {
    style: {
      padding: '10px',
      backgroundColor: 'white',
      borderBottom: '1px solid #ddd',
      '&:hover': {
        backgroundColor: '#d9d9d9'
      }
    }
  },
  cells: {
    style: {
      padding: '5px',
      borderRight: '1px solid #ddd',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  pagination: {
    style: {
      borderTop: '1px solid #ddd',
      padding: '0px',
      backgroundColor: '#f9f9f9',
      borderBottomLeftRadius: '12px',
      borderBottomRightRadius: '12px'
    }
  }
};

const resizeObserver = new ResizeObserver(
  debounce(() => {
    // handle resize if needed
  }, 200)
);
resizeObserver.observe(document.body);

export default Talika;